var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Office Insurance"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7475af",
    d: "M32.31 75.98h42.37v18.73H32.31z",
    opacity: 1,
    "data-original": "#7475af",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#60619b",
    d: "M32.31 92.21h42.37v2.5H32.31z",
    opacity: 1,
    "data-original": "#60619b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#60619b",
    d: "M32.31 75.98h17.5v18.73h-17.5z",
    opacity: 1,
    "data-original": "#60619b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#56578c",
    d: "M28.63 1.29h38.5v74.69h-38.5z",
    opacity: 1,
    "data-original": "#56578c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474882",
    d: "M28.63 23.16h21.18v52.82H28.63z",
    opacity: 1,
    "data-original": "#474882"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5b6191",
    d: "M28.63 1.29h38.5v6.87h-38.5z",
    opacity: 1,
    "data-original": "#5b6191",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7475af",
    d: "M33.65 4.13h28.47v4.04H33.65z",
    opacity: 1,
    "data-original": "#7475af",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5ecaff",
    d: "M33.65 12.6h6.13v6.13h-6.13zM44.81 12.6h6.13v6.13h-6.13zM55.97 12.6h6.14v6.13h-6.14z",
    opacity: 1,
    "data-original": "#5ecaff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M39.78 12.6v1.3l-4.83 4.83h-1.3v-3.02l3.11-3.11zM49.61 12.6l-4.8 4.8v-2.16l2.64-2.64zM62.11 12.6v.78l-5.35 5.35h-.79v-2.98l3.15-3.15z",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5ecaff",
    d: "M55.97 25.27h6.14v6.14h-6.14zM55.97 37.95h6.14v6.14h-6.14zM55.97 50.63h6.14v6.14h-6.14zM44.81 25.27h6.14v6.14h-6.14zM44.81 37.95h6.14v6.14h-6.14zM44.81 50.63h6.14v6.14h-6.14zM44.81 63.31h6.14v6.14h-6.14z",
    opacity: 1,
    "data-original": "#5ecaff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4a9dff",
    d: "M44.81 25.27h5v6.14h-5zM44.81 37.95h5v6.14h-5zM44.81 50.63h5v6.13h-5zM44.81 63.31h5v6.13h-5z",
    opacity: 1,
    "data-original": "#4a9dff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5ecaff",
    d: "M55.97 63.31h6.14v6.14h-6.14z",
    opacity: 1,
    "data-original": "#5ecaff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c2d4ff",
    d: "M3.03 23.16H45.4v52.82H3.03z",
    opacity: 1,
    "data-original": "#c2d4ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0edff",
    d: "M7.37 23.16h33.69v52.82H7.37z",
    opacity: 1,
    "data-original": "#e0edff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5ecaff",
    d: "M9.99 28.34h6.13v6.14H9.99zM21.15 28.34h6.13v6.14h-6.13zM32.31 28.34h6.14v6.14h-6.14zM9.99 39.84h6.13v6.14H9.99zM21.15 39.84h6.14v6.14h-6.14zM32.31 39.84h6.13v6.14h-6.13zM9.99 51.34h6.14v6.14H9.99zM21.15 51.34h6.13v6.14h-6.13zM32.31 51.34h6.14v6.14h-6.14zM9.99 62.84h6.13v6.14H9.99zM21.15 62.84h6.13v6.14h-6.13zM32.31 62.84h6.13v6.14h-6.13z",
    opacity: 1,
    "data-original": "#5ecaff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9aa7d2",
    d: "M9.99 17.58h12.25v5.58H9.99z",
    opacity: 1,
    "data-original": "#9aa7d2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7c89b4",
    d: "M3.03 75.99H45.4v18.73H3.03z",
    opacity: 1,
    "data-original": "#7c89b4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9aa7d2",
    d: "M7.37 75.98h33.69v18.73H7.37z",
    opacity: 1,
    "data-original": "#9aa7d2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7c89b4",
    d: "M3.03 92.21H45.4v2.5H3.03z",
    opacity: 1,
    "data-original": "#7c89b4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9aa7d2",
    d: "M3.03 75.99H45.4v6.52H3.03z",
    opacity: 1,
    "data-original": "#9aa7d2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c7cfff",
    d: "M7.37 75.98h33.69v6.52H7.37z",
    opacity: 1,
    "data-original": "#c7cfff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e8ff",
    d: "M36.52 79.24a1 1 0 0 1-1 1H13a1 1 0 1 1 0-2.06h22.49a1 1 0 0 1 1.03 1.06z",
    opacity: 1,
    "data-original": "#e0e8ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5ecaff",
    d: "M18.11 82.5h12.21v12.21H18.11z",
    opacity: 1,
    "data-original": "#5ecaff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0edff",
    d: "M23.22 82.5h2v12.21h-2z",
    opacity: 1,
    "data-original": "#e0edff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5ecaff",
    d: "M56.61 82.5h12.21v12.21H56.61z",
    opacity: 1,
    "data-original": "#5ecaff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0edff",
    d: "M61.72 82.5h2v12.21h-2z",
    opacity: 1,
    "data-original": "#e0edff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M30.32 87.75v3.72l-3.24 3.24h-3.72zM30.32 83.37v1.86l-9.48 9.48h-1.86zM27.35 82.5l-9.24 9.24V87l4.5-4.5zM68.82 88.74v3.71l-2.26 2.26h-3.71zM68.82 84.36v1.85l-8.49 8.5h-1.86zM66.83 82.5 56.61 92.72v-4.73l5.49-5.49z",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9798cd",
    d: "M56.61 75.98h18.07v3.26H56.61z",
    opacity: 1,
    "data-original": "#9798cd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m16.11 62.84-6.12 6.12v-4.6l1.52-1.52zM27.28 51.34v.32l-5.81 5.82h-.32V53.2l1.86-1.86zM38.44 39.84v.66l-5.48 5.48h-.65v-3.94l2.2-2.2zM26.73 57.48l.55-.55v.55zM15.23 68.98l.89-.89v.89zM27.28 62.84v5.13l-1.01 1.01h-5.12v-5.92l.22-.22zM32.31 62.84c.13 0 .13 0 0 .1zM38.44 45.77v.21h-.21zM16.12 28.34v3.65l-2.49 2.49H9.99v-2.42l3.72-3.72zM16.12 39.91v3.04l-3.03 3.03h-3.04zM27.28 28.76v3.03l-2.69 2.69h-3.04z",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7498f0",
    d: "M93 23v20.45c0 17.63-13.71 23.93-20.08 27.3l-.86.47c-5.11-2.88-11.23-5.59-15.74-11.53a25.16 25.16 0 0 1-5.16-13.89c-.13-1.7-.08-1.41-.08-22.8 3.12-.91 20.07-5.78 20.93-6 .1 0 14.72 4.19 20.99 6z",
    opacity: 1,
    "data-original": "#7498f0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#515cd2",
    d: "M91 41.34a1.47 1.47 0 0 1-1.47-1.47V28.23a3.5 3.5 0 0 0-1.31-2.72c-.79-.63-.14-.33-15.2-4.67a3.49 3.49 0 0 0-1.95 0c-15.35 4.42-14.44 4.05-15.2 4.67a3.49 3.49 0 0 0-1.31 2.72v11.64a1.47 1.47 0 0 1-1.48 1.47h-2c0 4.13 0 7.89 2 12.75C57.13 64 66.12 67.9 72 71.22l.86-.47C79.24 67.38 93 61.08 93 43.45v-2.11z",
    opacity: 1,
    "data-original": "#515cd2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffbd38",
    d: "M86.48 26.53a1.76 1.76 0 0 1 1.29 1.7c0 16.38.14 17-.42 19.89-1.79 9.41-8.91 13.81-14.49 16.79a1.79 1.79 0 0 1-1.68 0c-3.82-2.08-7.43-4.28-10.22-7.64a20.7 20.7 0 0 1-4.71-13.81V28.23a1.76 1.76 0 0 1 1.29-1.7l14-4c.65-.19.73-.07 4.26.94z",
    opacity: 1,
    "data-original": "#ffbd38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9f38",
    d: "M87.77 28.23v2.9a1.79 1.79 0 0 0-1.28-1.71c-1.44-.4-7.54-2.17-14-4-.67-.2.3-.37-15 4a1.8 1.8 0 0 0-1.29 1.71v-2.9a1.8 1.8 0 0 1 1.29-1.71l14-4c1-.26 1.65.3 15 4a1.79 1.79 0 0 1 1.28 1.71zM87.77 34.62c0 8.78.13 10.61-.42 13.5-1.79 9.39-8.89 13.8-14.46 16.77a1.82 1.82 0 0 1-1.74 0c-.78-.42-1.6-.88-2.24-1.26C80.76 57 87.77 48.56 87.77 34.62z",
    opacity: 1,
    "data-original": "#ff9f38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdb56",
    d: "M85.2 31.33A42.08 42.08 0 0 1 66.39 59a3.5 3.5 0 0 1-4.39-.57 20.58 20.58 0 0 1-5.75-15V31.3a2.07 2.07 0 0 1 1.49-2l13.48-3.88a2.83 2.83 0 0 1 1.58 0l10.65 3.07a2.48 2.48 0 0 1 1.75 2.84z",
    opacity: 1,
    "data-original": "#ffdb56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffff79",
    d: "m71.28 28.12-10.69 3.07a2.42 2.42 0 0 0-1.75 2.33v1.85a2.42 2.42 0 0 0 2.42 2.42h7.06a2.43 2.43 0 0 0 1.94-1l3.67-4.91a2.44 2.44 0 0 0-2.65-3.76z",
    opacity: 1,
    "data-original": "#ffff79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffbd38",
    d: "m68.16 52.41-6.35-4.95a2.16 2.16 0 1 1 2.65-3.4l4.73 3.69 10.07-11.68a2.16 2.16 0 1 1 3.26 2.82l-11.4 13.23a2.15 2.15 0 0 1-2.96.29z",
    opacity: 1,
    "data-original": "#ffbd38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#12c58b",
    d: "m68.16 49.18-6.35-5a2.16 2.16 0 1 1 2.65-3.4l4.73 3.68 10.07-11.63a2.16 2.16 0 1 1 3.26 2.82l-11.4 13.23a2.16 2.16 0 0 1-2.96.3z",
    opacity: 1,
    "data-original": "#12c58b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.15,
    height: 2.64,
    x: 61.56,
    y: 33.3,
    fill: "#ffdb56",
    rx: 0.82,
    opacity: 1,
    "data-original": "#ffdb56"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#302d3d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.78 11.6h-6.13a1 1 0 0 0-1 1v6.13a1 1 0 0 0 1 1h6.13a1 1 0 0 0 1-1V12.6a1 1 0 0 0-1-1zm-1 6.13h-4.13V13.6h4.13zM52 18.73V12.6a1 1 0 0 0-1-1h-6.19a1 1 0 0 0-1 1v6.13a1 1 0 0 0 1 1H51a1 1 0 0 0 1-1zm-2-1h-4.19V13.6H50zM16.12 27.34H10a1 1 0 0 0-1 1v6.14a1 1 0 0 0 1 1h6.13a1 1 0 0 0 1-1v-6.14a1 1 0 0 0-1.01-1zm-1 6.14H11v-4.14h4.13zM21.15 35.48c6.59 0 6.26 0 6.48-.07a1 1 0 0 0 .65-.93v-6.14a1 1 0 0 0-1-1h-6.13a1 1 0 0 0-1 1v6.14a1 1 0 0 0 1 1zm1-6.14h4.13v4.14h-4.13zM32.31 35.48h6.14a1 1 0 0 0 1-1v-6.14a1 1 0 0 0-1-1h-6.14a1 1 0 0 0-1 1v6.14a1 1 0 0 0 1 1zm1-6.14h4.14v4.14h-4.14zM16.12 38.84H10a1 1 0 0 0-1 1V46a1 1 0 0 0 1 1h6.13a1 1 0 0 0 1-1v-6.16a1 1 0 0 0-1.01-1zm-1 6.14H11v-4.14h4.13zM21.15 47c6.59 0 6.26 0 6.48-.07a1 1 0 0 0 .65-.93v-6.16a1 1 0 0 0-1-1h-6.13a1 1 0 0 0-1 1V46a1 1 0 0 0 1 1zm1-6.14h4.13V45h-4.13zM32.31 47h6.14a1 1 0 0 0 1-1v-6.16a1 1 0 0 0-1-1h-6.14a1 1 0 0 0-1 1V46a1 1 0 0 0 1 1zm1-6.14h4.14V45h-4.14zM16.12 50.34H10a1 1 0 0 0-1 1v6.14a1 1 0 0 0 1 1h6.13a1 1 0 0 0 1-1v-6.14a1 1 0 0 0-1.01-1zm-1 6.14H11v-4.14h4.13zM21.15 58.48c6.59 0 6.26 0 6.48-.07a1 1 0 0 0 .65-.93v-6.14a1 1 0 0 0-1-1h-6.13a1 1 0 0 0-1 1v6.14a1 1 0 0 0 1 1zm1-6.14h4.13v4.14h-4.13zM32.31 58.48h6.14a1 1 0 0 0 1-1v-6.14a1 1 0 0 0-1-1h-6.14a1 1 0 0 0-1 1v6.14a1 1 0 0 0 1 1zm1-6.14h4.14v4.14h-4.14zM16.12 61.84H10a1 1 0 0 0-1 1V69a1 1 0 0 0 1 1h6.13a1 1 0 0 0 1-1v-6.16a1 1 0 0 0-1.01-1zm-1 6.14H11v-4.14h4.13zM28.28 69v-6.16a1 1 0 0 0-.65-.93c-.22-.1.21-.07-6.48-.07a1 1 0 0 0-1 1V69a1 1 0 0 0 1 1h6.13a1 1 0 0 0 1-1zm-2-1h-4.13v-4.16h4.13zM32.31 70h6.14a1 1 0 0 0 1-1v-6.16a1 1 0 0 0-1-1h-6.14a1 1 0 0 0-1 1V69a1 1 0 0 0 1 1zm1-6.14h4.14V68h-4.14z",
    fill: "#302d3d",
    opacity: 1,
    "data-original": "#302d3d",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.63 22.28a.9.9 0 0 0-.4-.26C92.84 21.94 72.29 16 72 16s.1-.07-3.88 1.07V1.29a1 1 0 0 0-1-1H28.63a1 1 0 0 0-1 1v20.87h-4.39v-4.58a1 1 0 0 0-1-1H10a1 1 0 0 0-1 1v4.58H3a1 1 0 0 0-1 1v71.55a1 1 0 0 0 1 1h71.68a1 1 0 0 0 1-1V76a1 1 0 0 0-1-1h-6.55v-4.73c3.8 2 3.55 2 3.88 2s.33-.08 2.27-1.08C81.16 67.54 94 60.85 94 43.44c0-22.44.1-20.72-.37-21.16zm-2.88 1.11-3.18 2.39L73 21.59v-3.3c23.47 6.71 16.4 4.76 17.75 5.1zM72 64.22c-6.64-3.54-11.8-7.19-14-14.59-1.09-3.87-.81-6.16-.81-22L72 23.39l14.76 4.25v15.8c.01 12.69-9 17.76-14.76 20.78zm-1-45.93v3.3l-14.55 4.19-3.18-2.39zM4 81.5V77h40.4v4.5zm42.4-17.19H50v4.13h-3.6zM50.07 37H46.4v-4.59h3.67zm-3.67 2H50v4.14h-3.6zm3.6-8.59h-3.6v-4.14H50zm-3.6 21.22H50v4.13h-3.6zm0-2v-4.54h3.71a28.92 28.92 0 0 0 .55 4.54zm14.71-31.9H57V13.6h4.14zM29.63 2.29h36.5v4.87h-36.5zm0 6.87h36.5v8.45l-3 .87V12.6a1 1 0 0 0-1-1H56a1 1 0 0 0-1 1v6.13a1 1 0 0 0 1 1h2.79c-8.47 2.44-8.19 2.25-8.49 2.65s-.2.5-.2 1.89h-3.7v-1.11a1 1 0 0 0-1-1H29.63zM11 18.58h10.24v3.58H11zm-7 5.58h40.4V75H4zM4 83.5h13.11v10.21H4zm15.08 0h4.1v10.21h-4.1zm6.1 10.21V83.5h4.11v10.21zm6.11 0V83.5H44.4v10.21zm26.29 0V83.5h4.1v10.21zm6.1 0V83.5h4.11v10.21zm10 0h-3.86V82.5a1 1 0 0 0-1-1H56.61a1 1 0 0 0-1 1v11.21H46.4V77h27.28zM66.13 75H46.4v-4.56H51a1 1 0 0 0 1-1v-6.13a1 1 0 0 0-1-1h-4.6v-4.55H51a1 1 0 0 0 1-1V54.1a25.19 25.19 0 0 0 5.2 8.21H56a1 1 0 0 0-1 1v6.13a1 1 0 0 0 1 1h6.14a1 1 0 0 0 1-1v-2.15c1 .68 2 1.3 3 1.87zm-5-9.12v2.58H57v-4.15h2.25c.59.55 1.22 1.07 1.86 1.55zm7 2.13C57.88 62.31 52.07 55 52.07 43.44V25l3.17 2.39v16.05A23.79 23.79 0 0 0 57 52.69c2.73 6.58 8.16 10.09 14 13.25v3.6c-.16-.09-1.41-.74-2.87-1.54zM73 69.55V66c5.79-3 15.76-8.69 15.76-22.52v-16.1L92 25v18.44c0 12.99-7.49 20.36-19 26.11z",
    fill: "#302d3d",
    opacity: 1,
    "data-original": "#302d3d",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 34a3.16 3.16 0 0 0-5.54-1.83l-9.45 11c-2.45-1.92-1.38-1.06-4-3.1a3.16 3.16 0 0 0-3.88 5l4.94 3.85a11.32 11.32 0 0 0 2 1.46 3.13 3.13 0 0 0 3.74-.79l11.47-13.3A3.14 3.14 0 0 0 84 34zm-2.27 1L70.36 48.23a1.19 1.19 0 0 1-1.59.15l-6.35-5a1.16 1.16 0 0 1 .71-2.07c.61 0 .5.11 5.44 3.93a1 1 0 0 0 1.37-.13L80 33.47a1.16 1.16 0 0 1 2 .67 1.11 1.11 0 0 1-.23.86z",
    fill: "#302d3d",
    opacity: 1,
    "data-original": "#302d3d",
    className: ""
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.ba4453134529d86992d07c55055cd6d4.svg";
export { ForwardRef as ReactComponent };